import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';
import React from 'react';
import { PropTypes as PropTypes$1 } from '@micromag/core';

var styles = {"container":"micromag-element-grid-container","items":"micromag-element-grid-items","cross":"micromag-element-grid-cross","axis":"micromag-element-grid-axis"};

var propTypes = {
  layout: PropTypes$1.gridLayout,
  items: PropTypes.arrayOf(PropTypes.node),
  width: PropTypes.number,
  height: PropTypes.number,
  spacing: PropTypes.number,
  vertical: PropTypes.bool,
  className: PropTypes.string,
  axisClassName: PropTypes.string,
  crossClassName: PropTypes.string
};
var defaultProps = {
  layout: null,
  items: [],
  width: null,
  height: null,
  spacing: 0,
  vertical: false,
  className: null,
  axisClassName: null,
  crossClassName: null
};
function Grid(_ref) {
  var items = _ref.items,
    layout = _ref.layout,
    width = _ref.width,
    height = _ref.height,
    spacing = _ref.spacing,
    vertical = _ref.vertical,
    className = _ref.className,
    axisClassName = _ref.axisClassName,
    crossClassName = _ref.crossClassName;
  var itemIndex = 0;
  var finalLayout = isArray(layout) ? layout : [{
    rows: vertical ? items.map(function () {
      return 1;
    }) : 1,
    columns: vertical ? 1 : items.map(function () {
      return 1;
    })
  }];
  var crossTotal = finalLayout.reduce(function (total, _ref2) {
    var _ref2$rows = _ref2.rows,
      rows = _ref2$rows === void 0 ? 1 : _ref2$rows,
      _ref2$columns = _ref2.columns,
      columns = _ref2$columns === void 0 ? 1 : _ref2$columns;
    return total + (vertical ? columns : rows);
  }, 0);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    style: {
      width: width,
      height: height,
      padding: spacing !== null && spacing > 0 ? spacing / 2 : null
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.items,
    style: {
      flexDirection: vertical ? 'row' : 'column'
    }
  }, finalLayout.map(function (_ref4, crossIndex) {
    var rows = _ref4.rows,
      columns = _ref4.columns;
    var crossSizeRatio = (vertical ? columns : rows) / crossTotal;
    var crossSize = "".concat(100 * crossSizeRatio, "%");
    var axisItems = vertical ? rows : columns;
    var finalAxisItems = isArray(axisItems) ? axisItems : [axisItems];
    var axisTotal = finalAxisItems.reduce(function (total, it) {
      return total + it;
    }, 0);
    return /*#__PURE__*/React.createElement("div", {
      key: "cross-".concat(crossIndex),
      className: classNames([styles.cross, _defineProperty({}, crossClassName, crossClassName !== null)]),
      style: {
        flexDirection: vertical ? 'column' : 'row',
        width: vertical ? crossSize : null,
        height: vertical ? null : crossSize
      }
    }, finalAxisItems.map(function (axisItem, axisIndex) {
      var axisSizeRatio = axisItem / axisTotal;
      var axisSize = "".concat(100 * axisSizeRatio, "%");
      var item = items[itemIndex];
      itemIndex += 1;
      return /*#__PURE__*/React.createElement("div", {
        key: "axis-".concat(axisIndex),
        className: classNames([styles.axis, _defineProperty({}, axisClassName, axisClassName !== null)]),
        style: {
          width: vertical ? null : axisSize,
          height: vertical ? axisSize : null,
          padding: spacing > 0 ? spacing / 2 : 0
        }
      }, item);
    }));
  })));
}
Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

export { Grid as default };
